// store/slices/notificationSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AlertProps } from "@mui/material";
import { v4 } from "uuid";
import { AdronSeverity } from "../../_app/types";

interface Notification {
  id: string;
  message: string;
  severity: AdronSeverity;
  autoHideDuration: number;
  title?: string;
}

interface NotificationState {
  notifications: Notification[];
}

const initialState: NotificationState = {
  notifications: [],
};

const notificationSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    showNotification: (
      state,
      action: PayloadAction<{ message: string; severity: AdronSeverity; autoHideDuration?: number }>
    ) => {
      const autoHideDuration = action.payload.autoHideDuration ?? 3000;
      const id = v4();
      state.notifications.push({
        id,
        message: action.payload.message,
        severity: action.payload.severity,
        autoHideDuration,
      });
    },
    setNotifications: (state, action: PayloadAction<Notification[]>) => {
      state.notifications = action.payload;
    },
    hideNotification: (state, action: PayloadAction<string>) => {
      state.notifications = state.notifications.filter(
        (notification) => notification.id !== action.payload
      );
    },
  },
});

export const { showNotification, hideNotification, setNotifications } = notificationSlice.actions;
export default notificationSlice.reducer;
